// import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './routes/ProtectedRoute';
import AppNavbar from './components/NavBar';
import ClientLanding from './pages/ClientLanding';
import JustizLanding from './pages/JustizLanding';
import MedProdRegister from './pages/Medizinprodukteregister';
import Standards from './pages/Standards';
import DocumentList from './pages/DocumentList';
import AdminLaws from './pages/AdminLaws';
import AdminProcessMaps from './pages/AdminProcessMaps';
import PasswordChange from './pages/PasswordChange';
import PasswordReset from './pages/PasswordReset';
import PasswordRequest from './pages/PasswordRequest';
// import Home from './pages/Home';
import Tasks from './pages/Tasks';
import Logs from './pages/Logs';
import DecisionRegister from './pages/DecisionRegister';
import DecisionDashboard from './pages/DecisionDashboard';
import ClientSelection from './pages/ClientSelection';

const dashboardElement = (<ProtectedRoute><Dashboard /></ProtectedRoute>);
const documentListElement = (<ProtectedRoute><DocumentList /></ProtectedRoute>);
const clientLandingElement = (<ProtectedRoute requiredRole="client"><ClientLanding /></ProtectedRoute>);
const passwordChangeElement = (<ProtectedRoute><PasswordChange /></ProtectedRoute>);
const justizLandingElement = (<ProtectedRoute requiredRole="justiz"><JustizLanding /></ProtectedRoute>);
const MedProdRegisterElement = (<ProtectedRoute requiredRole="justiz"><MedProdRegister /></ProtectedRoute>);
const StandardsElement = (<ProtectedRoute requiredRole="justiz"><Standards /></ProtectedRoute>);
const TasksElement = (<ProtectedRoute requiredRole="justiz"><Tasks /></ProtectedRoute>);
const AdminLawsElement = (<ProtectedRoute requiredRole={["superadmin", "lawyer"]}><AdminLaws /></ProtectedRoute>);
const LogsElement = (<ProtectedRoute requiredRole="superadmin"><Logs /></ProtectedRoute>);
const AdminProcessMapsElement = (<ProtectedRoute requiredRole={["superadmin", "lawyer"]}><AdminProcessMaps /></ProtectedRoute>);
const DecisionRegisterElement = (<ProtectedRoute requiredRole={["client", "superadmin", "lawyer"]}><DecisionRegister /></ProtectedRoute>);
const DecisionDashboardElement = (<ProtectedRoute requiredRole={["superadmin", "lawyer"]}><DecisionDashboard /></ProtectedRoute>);
const ClientSelectionElement = (<ProtectedRoute requiredRole={["superadmin", "lawyer"]}><ClientSelection /></ProtectedRoute>);

function ExternalRedirect() {
  window.location.replace("https://www.ilct.eu");
  return null;
}

const App = () => {
  return (
    <>
      <AppNavbar />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/client"
          element={
            <ProtectedRoute requiredRole="client">
              <ClientLanding />
            </ProtectedRoute>
          }
        />
        <Route
          path="/medizinprodukteregister"
          element={
            <ProtectedRoute requiredRole="justiz">
              <MedProdRegister />
            </ProtectedRoute>
          }
        />
        <Route
          path="/standards"
          element={
            <ProtectedRoute requiredRole="justiz">
              <Standards />
            </ProtectedRoute>
          }
        />
        <Route
          path="/justiz"
          element={
            <ProtectedRoute requiredRole="justiz">
              <JustizLanding />
            </ProtectedRoute>
          }
        />
        <Route
          path="/documents/:law_part_id?"
          element={
            <ProtectedRoute>
              <DocumentList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/massnahmen"
          element={
            <ProtectedRoute>
              <Tasks />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/bescheide"
          element={
            <ProtectedRoute requiredRole="client">
              <DecisionRegister />
            </ProtectedRoute>
          }
        /> */}
        <Route path="/password-request" element={<PasswordRequest />} /* Passwort vergessen? */ /> 
        <Route path="/password-reset" element={<PasswordReset />} /* Neue Passwort eingeben */ />
        <Route /* Passwort ändern */
          path="/password-change"
          element={
            <ProtectedRoute>
              <PasswordChange />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/laws"
          element={
            <ProtectedRoute requiredRole={["superadmin", "lawyer"]}>
              <AdminLaws />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/logs"
          element={
            <ProtectedRoute requiredRole="superadmin">
              <Logs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/processmaps"
          element={
            <ProtectedRoute requiredRole={["superadmin", "lawyer"]}>
              <AdminProcessMaps />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/decision-dashboard"
          element={
            <ProtectedRoute requiredRole={['superadmin', 'lawyer']}>
              <DecisionDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/clientselection"
          element={
            <ProtectedRoute requiredRole={['superadmin', 'lawyer']}>
              <ClientSelection />
            </ProtectedRoute>
          }
        />
        <Route path="/" index element={<ExternalRedirect />} />
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<h2>403 - Access Denied - Try something else</h2>} /* TODO: Create a proper Unauthorized page with navigation options */ />
        <Route path="/password-request" element={<PasswordRequest />} /* Passwort vergessen? */ /> 
        <Route path="/password-reset" element={<PasswordReset />} /* Neues Passwort eingeben */ />

        <Route path="/admin/laws" element={AdminLawsElement} /* Neues Passwort eingeben */ />
        <Route path="/admin/logs" element={LogsElement} /* Neues Passwort eingeben */ />
        <Route path="/admin/processmaps" element={AdminProcessMapsElement} /* Neues Passwort eingeben */ />

        {[
          "/dashboard", 
          "/:clientSlug/dashboard"
        ].map((path) => (<Route key={path} path={path} element={dashboardElement} />))}
        {[
          "/documents/:law_part_id?", 
          "/vorschriften/:law_part_id?", 
          "/:clientSlug/documents/:law_part_id?", 
          "/:clientSlug/vorschriften/:law_part_id?"
        ].map((path) => (<Route key={path} path={path} element={documentListElement} />))}
        {[
          "/client", 
          "/kunde", 
          "/:clientSlug/client", 
          "/:clientSlug/kunde"
        ].map((path) => (<Route key={path} path={path} element={clientLandingElement} />))}
        {[
          "/clientselection",
          "/kundenwahl",
          "/:clientSlug/clientselection",
          "/:clientSlug/kundenwahl"
        ].map((path) => (<Route key={path} path={path} element={ClientSelectionElement} />))}
        {[
          "/password-change", 
          "/:clientSlug/password-change", 
          "/passwort-aendern", 
          "/:clientSlug/passwort-aendern"
        ].map((path) => (<Route key={path} path={path} element={passwordChangeElement} /* Passwort ändern */ />))}
        {[
          "/justiz", 
          "/:clientSlug/justiz"
        ].map((path) => (<Route key={path} path={path} element={justizLandingElement} />))}
        {[
          "/medizinprodukteregister", 
          "/:clientSlug/medizinprodukteregister"
        ].map((path) => (<Route key={path} path={path} element={MedProdRegisterElement} />))}
        {[
          "/standards", 
          "/:clientSlug/standards"
        ].map((path) => (<Route key={path} path={path} element={StandardsElement} />))}
        {[
          "/massnahmen", 
          "/:clientSlug/massnahmen"
        ].map((path) => (<Route key={path} path={path} element={TasksElement} />))}
        {[
          "/bescheide/:decision_id?", 
          "/decisions/:decision_id?",
          "/:clientSlug/bescheide/:decision_id?",
          "/:clientSlug/decisions/:decision_id?"
        ].map((path) => (<Route key={path} path={path} element={DecisionRegisterElement} />))}
        {[
          "/admin/decision-dashboard"
        ].map((path) => (<Route key={path} path={path} element={DecisionDashboardElement} />))}

        <Route path="*" element={<h2>404 - Page Not Found</h2>} /* TODO: Create a proper Not Found page with navigation options */ />
      </Routes>
    </>
  );
};

export default App;
